const labels = {
  'done-page-heading': 'Success',
  'done-transaction-preamble': 'Your Service Victoria transaction reference number',
  'home-banner':
    'Construction site operators must complete this declaration before returning to work. The declaration details the COVID related health and safety responsibilities site operators must uphold at all worksites.',
  'home-clock-preamble': 'This takes about',
  'home-get-started': 'Get started',
  'home-tab-1': 'Before you start',
  'home-tab-2': "What you'll need",
  'home-tab-3': 'FAQ',
  'home-time-to-complete': '5 mins',
  'page-title': 'COVIDSafe construction declaration',
  'review-checkbox-label': 'I will ensure compliance',
  'review-legal-obligation-accordion-title': 'Your legal obligations',
  'review-mandatory-vaccination-accordion-title': 'Mandatory vaccination advice',
  'review-obligation-section': 'Rules for the construction industry',
  'review-page-title': 'Review your details',
  'review-records-title': 'I confirm that I have records of:',
  'review-worksite-title': 'I confirm that those on my worksite:',
  'review-worksite-2-title': 'I confirm my site:'
};

export default function content(label: keyof typeof labels): string {
  return labels[label];
}
